import React, { useEffect, useState } from "react";
import "./ui.css";
import { Btn, FormInput, FormTextArea, SuccessComp } from "../../utils/utils";
import star from "../../assets/star.png";
import { useNavigate, useParams } from "react-router-dom";
import { AxiosAuthGet, AxiosGet, AxiosPost } from "../../api/api";
import Loading from "./Loading";
import SwiperComp from "../swiper/Swiper";

const HouseDetails = ({houseWidth, styleBg, leftWidth}) => {
  const user = JSON.parse(localStorage.getItem("apk"));
  const url = "property/schedule-visit/";
  const navigate = useNavigate();
  const param = useParams();
  const propAgentUrl = `agent/properties/${param?.id}/`;
  const propUrl = `property/${param?.id}/`;
  
  

  const [data, setData] = useState({
    name: "",
    phoneNumber: "",
    message: "",
  });
  const [dataErr, setDataErr] = useState({
    name: "",
    phoneNumber: "",
    message: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isSingleLoading, setIsSingleLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [propData, setPropData] = useState("");

  const handleData = (e) => {
    const newData = { ...data };
    newData[e.target.id] = e.target.value;
    setData(newData);
    const newDataErr = { ...dataErr };
    newDataErr[e.target.id] = "";
    setDataErr(newDataErr);
    // console.log(newData);
  };

  const getSingleAgentProp = () => {
    setIsSingleLoading(true)
    AxiosAuthGet(propAgentUrl).then((res) => {
      // console.log(res);
      setPropData(res.data);
      setIsSingleLoading(false)
    }).catch((err) => {
      // console.log(err.response);
      setIsSingleLoading(false)
    })
  }
  const getSingleProp = () => {
    setIsSingleLoading(true)
    AxiosGet(propUrl).then((res) => {
      // console.log(res);
      setPropData(res.data);
      setIsSingleLoading(false)
    }).catch((err) => {
      // console.log(err.response);
      setIsSingleLoading(false)
    })
  }

  useEffect(() => {
    if (user){
      getSingleAgentProp();
    } else {
      getSingleProp();
    }
    // eslint-disable-next-line 
  }, [param]);

  const dataObj = {
    propertyId: propData?.id,
    name: data?.name,
    phoneNumber: data?.phoneNumber,
    message: data?.message,
  };

  const submitSchedule = () => {
    setIsLoading(true);
    AxiosPost(url, dataObj)
      .then((res) => {
        // console.log(res);
        setSuccessMsg(res.message);
        setTimeout(() => {
          setSuccessMsg("");
        }, 3000);
        setIsLoading(false);
      })
      .catch((err) => {
        // console.log(err.response);
        for (let i = 0; i < err?.response?.data?.errors?.length; i++) {
          const fieldName = err?.response?.data?.errors[i].fieldName;
          const error = err?.response?.data?.errors[i].error;
          setDataErr((prevErrs) => ({
            ...prevErrs,
            [fieldName]: error,
          }));
        }
        setIsLoading(false);
      });
  };

  const prevArr = [
    {
      title: "House Type:",
      text: propData?.propertyCategory,
    },
    {
      title: "Bedrooms:",
      text: `${propData?.bedrooms} Bedrooms`,
    },
    {
      title: "Bathrooms:",
      text: `${propData?.bathrooms} Bathrooms`,
    },
    {
      title: "Year Built:",
      text: propData?.yearBuilt,
    },
  ];
  const starImg = [star, star, star, star, star];

  const editProp = () => {
    navigate("/agent/property/edit");
  };

  return (
    <>
    {isSingleLoading && <Loading />}
    {!isSingleLoading && <div className="house-details" style={{width: houseWidth}}>
      <SuccessComp message={successMsg} />
      <div className="house-details_top">
        <SwiperComp images={propData?.images} />
        {/* <div className="details-left">
          <img src={propData?.images?.[0]?.link} alt="house" />
        </div> */}
        {/* <div className="details-right"> */}
          {/* {propData?.images?.map((item, i) => {
            return(
              <img key={i} src={item?.link} alt="house" />
            )
          })} */}
          {/* {propData?.images?.[2]?.link && (
            <div className="details-view_cont">
              <img src={propData?.images?.[2]?.link} alt="house" />
              <div className="details-view">
                <p>View Photos</p>
              </div>
            </div>
          )} */}
        {/* </div> */}
      </div>
      <div className="house-details_btm">
        <div className="house-info">
          <div className="info-left" style={{width: leftWidth}}>
            <div className="info-head">
              <div className="info-head_left">
                <div style={{ display: "inline-flex" }}>
                  <h3>{propData?.propertyType}</h3>
                </div>

                <h2>{propData?.name}</h2>
                <p>{propData?.propertyAddress}</p>
                {propData && user && (
                  <Btn
                    btnText={"Edit property"}
                    btnClick={editProp}
                    btnClass={"home-btn"}
                  />
                )}
              </div>
              <div className="info-head_right">
                {propData?.propertyType === "Rent" && (
                  <h5>
                    {`#${propData?.propertyPrice?.toLocaleString()}`}/annum
                  </h5>
                )}
                {propData?.propertyType === "Sell" && (
                  <h5>{`#${propData?.propertyPrice?.toLocaleString()}`}</h5>
                )}
              </div>
            </div>
            <div className="info-prev info-style" style={{background: styleBg}}>
              <h4>Property Overview</h4>
              <div className="infor-prev_btm-cont">
                {prevArr.map((item, i) => {
                  return (
                    <div key={i} className="infor-prev_btm">
                      <h4>{item.title}</h4>
                      <p>{item.text}</p>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="info-desc info-style" style={{background: styleBg}}>
              <h4>Property Description</h4>
              <p>{propData?.propertyDescription}</p>
            </div>
            {/* <div className="info-map info-style">
              <img src={map} alt="map" />
            </div> */}
          </div>
          {!user && (
            <div className="info-right">
              <h3>Schedule a visit</h3>
              <div className="info-right_form">
                <FormInput
                  type="text"
                  label={"Full Name"}
                  labelBg={"#FFF8F2"}
                  changeInput={handleData}
                  id={"name"}
                  err={dataErr?.name}
                />
                <FormInput
                  type="text"
                  label={"Phone Number"}
                  labelBg={"#FFF8F2"}
                  changeInput={handleData}
                  id={"phoneNumber"}
                  err={dataErr?.phoneNumber}
                />
                <FormTextArea
                  label={"Drop a message"}
                  labelBg={"#FFF8F2"}
                  changeInput={handleData}
                  id={"message"}
                  err={dataErr?.message}
                />
                <div className="info-form_btn">
                  <Btn
                    btnClass={"home-btn"}
                    btnText={"Schedule Visit"}
                    loading={isLoading}
                    btnClick={submitSchedule}
                  />
                </div>
              </div>
              <div className="info-right_agent">
                <div className="agent-head">
                  <div className="head-left">
                    <img src={propData?.owner?.picture} alt="agent" />
                    <div className="head-left_right">
                      <h6>{propData?.owner?.name}</h6>
                      <div className="hhr-img">
                        <div className="hrr-img_img">
                          {starImg.map((item, i) => {
                            return <img key={i} src={item} alt="star" />;
                          })}
                        </div>
                        <p>
                          {propData?.owner?.totalRatings} (
                          {propData?.owner?.ratingCount} Reviews)
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="agent-info_btn">
                  <Btn
                    btnClick={() => {window.location.href= `tel:${"+234" + parseInt(propData?.owner?.phoneNumber.toString().slice(1))}`}}
                    btnClass={"home-btn"}
                    btnText={"Call Us"}
                  />
                  <Btn
                    href={`https://wa.me/${"+234" + parseInt(propData?.owner?.phoneNumber.toString().slice(1))}?text=I'm%20interested%20in%20a%20property%20you%20posted%20on%20Prime-Property`}
                    btnClass={"home-btn"}
                    btnText={"Whatsapp"}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>}
    </>
  );
};

export default HouseDetails;
